/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryCommentResponse } from './RevisdomAPIViewModelsEntryCommentResponse';
import {
    RevisdomAPIViewModelsEntryCommentResponseFromJSON,
    RevisdomAPIViewModelsEntryCommentResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryCommentResponseToJSON,
    RevisdomAPIViewModelsEntryCommentResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryCommentResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1CommentResponse
 */
export interface ApiResponse1CommentResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1CommentResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1CommentResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryCommentResponse}
     * @memberof ApiResponse1CommentResponse
     */
    data?: RevisdomAPIViewModelsEntryCommentResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1CommentResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1CommentResponse interface.
 */
export function instanceOfApiResponse1CommentResponse(value: object): value is ApiResponse1CommentResponse {
    return true;
}

export function ApiResponse1CommentResponseFromJSON(json: any): ApiResponse1CommentResponse {
    return ApiResponse1CommentResponseFromJSONTyped(json, false);
}

export function ApiResponse1CommentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1CommentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryCommentResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1CommentResponseToJSON(json: any): ApiResponse1CommentResponse {
    return ApiResponse1CommentResponseToJSONTyped(json, false);
}

export function ApiResponse1CommentResponseToJSONTyped(value?: ApiResponse1CommentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryCommentResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

